/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$S as $S,
  rec_JSXRuntime as JSXRuntime,
  rec_Pi as Pi,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_TarjetaTarea as TarjetaTarea,
  rec_eC as eC,
  rec_mS as mS,
  rec_ra as ra,
  rec_st as st,
} from "../../runtime/index.jsx";
export function BusquedaGlobal() {
  let e = (0, ReactCompiler.c)(26),
    t = st(),
    [n, r] = (0, React.useState)(!1),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(null),
    c = (0, React.useRef)(null),
    { resultados: l, buscando: u } = $S(i),
    f,
    p;
  (e[0] === n
    ? ((f = e[1]), (p = e[2]))
    : ((f = () => {
        if (!n) return;
        let e = (e) => c.current && !c.current.contains(e.target) && r(!1),
          t = (e) => e.key === `Escape` && r(!1);
        return (
          document.addEventListener(`mousedown`, e),
          document.addEventListener(`keydown`, t),
          () => {
            (document.removeEventListener(`mousedown`, e),
              document.removeEventListener(`keydown`, t));
          }
        );
      }),
      (p = [n]),
      (e[0] = n),
      (e[1] = f),
      (e[2] = p)),
    (0, React.useEffect)(f, p));
  let m;
  e[3] === t
    ? (m = e[4])
    : ((m = function (e) {
        (r(!1), a(``), e.tipo === `TAREA` ? s(e.id) : t(mS(e)));
      }),
      (e[3] = t),
      (e[4] = m));
  let h = m,
    _;
  e[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((_ = (
        <Pi
          className={`pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`}
        />
      )),
      (e[5] = _))
    : (_ = e[5]);
  let v, y;
  e[6] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((v = (e) => a(e.target.value)),
      (y = () => r(!0)),
      (e[6] = v),
      (e[7] = y))
    : ((v = e[6]), (y = e[7]));
  let b, x;
  e[8] === i
    ? ((b = e[9]), (x = e[10]))
    : ((b = (
        <input
          value={i}
          onChange={v}
          onFocus={y}
          placeholder={`Buscar proyectos, tareas, reuniones…`}
          className={`w-full rounded-full border border-(--border) bg-(--bg) py-1.5 pl-9 pr-8 text-sm text-(--text-h) outline-none transition focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
        />
      )),
      (x = i && (
        <button
          type={`button`}
          onClick={() => a(``)}
          aria-label={`Limpiar`}
          className={`absolute right-2.5 top-1/2 -translate-y-1/2 text-(--text) hover:text-(--text-h)`}
          children={(0, JSXRuntime.jsx)(ra, {
            className: `h-3.5 w-3.5`,
          })}
        />
      )),
      (e[8] = i),
      (e[9] = b),
      (e[10] = x));
  let S;
  e[11] !== b || e[12] !== x
    ? ((S = <div className={`relative`} children={[_, b, x]} />),
      (e[11] = b),
      (e[12] = x),
      (e[13] = S))
    : (S = e[13]);
  let C;
  e[14] !== n || e[15] !== u || e[16] !== h || e[17] !== i || e[18] !== l
    ? ((C = n && i.trim().length >= 2 && (
        <div
          className={`animar-entrada absolute left-0 z-40 mt-1 w-full min-w-72 overflow-hidden rounded-2xl border border-(--border) bg-(--bg) shadow-2xl`}
          children={
            u ? (
              <p
                className={`px-3 py-4 text-center text-sm text-(--text)`}
                children={`Buscando…`}
              />
            ) : l.length === 0 ? (
              <p
                className={`px-3 py-4 text-center text-sm text-(--text)`}
                children={`Sin resultados.`}
              />
            ) : (
              <ul
                className={`max-h-80 overflow-y-auto`}
                children={l.map((e) => (
                  <li
                    key={`${e.tipo}-${e.id}`}
                    children={
                      <button
                        type={`button`}
                        onClick={() => h(e)}
                        className={`flex w-full flex-col items-start gap-0.5 border-b border-(--border) px-3 py-2 text-left transition last:border-0 hover:bg-(--accent-bg)`}
                        children={[
                          <span
                            className={`flex w-full items-center gap-2`}
                            children={[
                              <span
                                className={`rounded bg-(--panel) px-1.5 py-0.5 text-[10px] uppercase text-(--text)`}
                                children={eC[e.tipo] ?? e.tipo}
                              />,
                              <span
                                className={`min-w-0 flex-1 truncate text-sm text-(--text-h)`}
                                children={e.titulo}
                              />,
                            ]}
                          />,
                          e.tipo !== `PROYECTO` && (
                            <span
                              className={`pl-0.5 text-xs text-(--text)`}
                              children={e.proyectoNombre}
                            />
                          ),
                        ]}
                      />
                    }
                  />
                ))}
              />
            )
          }
        />
      )),
      (e[14] = n),
      (e[15] = u),
      (e[16] = h),
      (e[17] = i),
      (e[18] = l),
      (e[19] = C))
    : (C = e[19]);
  let w;
  e[20] === o
    ? (w = e[21])
    : ((w = o && <TarjetaTarea tareaId={o} onClose={() => s(null)} />),
      (e[20] = o),
      (e[21] = w));
  let T;
  return (
    e[22] !== w || e[23] !== S || e[24] !== C
      ? ((T = (
          <div
            className={`relative w-full max-w-xs sm:max-w-md`}
            ref={c}
            children={[S, C, w]}
          />
        )),
        (e[22] = w),
        (e[23] = S),
        (e[24] = C),
        (e[25] = T))
      : (T = e[25]),
    T
  );
}
